import { AsyncPipe, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TenantUsersDto } from '@buspro/web/apis';
import { TenantAuthService } from '@buspro/web/core';
import { NgxAuthService } from '@corelabs/ng-auth';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { AvatarModule } from 'ngx-avatars';
import { Observable } from 'rxjs';

@Component({
  selector: 'tenant-mobile-nav',
  templateUrl: './mobile-nav.component.html',
  styleUrls: ['./mobile-nav.component.scss'],
  imports: [RouterLink, RouterLinkActive, NgIf, AsyncPipe, AvatarModule, NzButtonComponent],
  standalone: true,
})
export class MobileNavComponent {
  private authService = inject(TenantAuthService);
  private ngxAuthService = inject(NgxAuthService);
  authUser$: Observable<TenantUsersDto | null> = this.ngxAuthService.state;
  logout() {
    this.authService.logout();
  }
}
